import { EntityConfig } from "../..";
import { genericGet } from "../../services/api.service";
import { TipoOperacao } from "../Obras/newObra/IObra";

export const NotificationsTableConfigs : EntityConfig = [
    {
        id: 'id',
        label: 'Id',
        type: 'id',
        nonEditable: true
      },
    {
      id: 'entity',
      label: 'Entidade',
      type: 'text',
      filterable: true
    },
    {
      id: 'notificationOffset',
      label: 'Offset para notificação (dias)',
        type: 'number'
    },
    {
      id: 'sendEmail',
      label: 'Gerar Email',
      type: 'boolean'
    }
  ];
  
export const ClientsFornecedoresTableConfig : EntityConfig = [

  {
    id: 'id',
    label: 'Id',
    type: 'id',
    nonEditable: true
  },

  {
    id: 'name',
    label: 'Nome',
    type: 'text',
    filterable: true
  },

  {
    id: 'address',
    label: 'Endereço',
    type: 'text',
    filterable: true
  },
  {
    id: 'phone',
    label: 'Contacto telefónico',
    type: 'text',
    filterable: true
  },
  {
    id: 'email',
    label: 'Email',
    type: 'text',
    filterable: true
  },
  {
    id: 'nif',
    label: 'NIF',
    type: 'text'
  },
  {
    id: 'numeroCliente',
    label: 'Número Cliente (faturação)',
    type: 'text'
  },
  {
    id: 'paymentTime',
    type: 'number',
    label: 'Prazo de pagamento (dias)',
  },

  {
    id: 'score',
    type: 'number',
    label: 'Score',
  },
  {
    id: 'distancia',
    type: 'number',
    label: 'Distância (km)',
  }


]


export const MachinesTableConfig : EntityConfig = [

  {
    id: 'id',
    label: 'Id',
    type: 'id',
    nonEditable: true
  },

  {
    id: 'brand',
    label: 'Marca',
    type: 'text',
    filterable: true
  },

  {
    id: 'model',
    label: 'Modelo',
    type: 'text',
    filterable: true
  },
  {
    id: 'axis',
    type: 'number',
    label: 'Número de eixos',
    filterable: true
  },
  {
    id: 'ref',
    label: 'Ref',
    type: 'text',
    filterable: true
  },
  {
    id: 'ip',
    label: 'IP',
    type: 'text',
    filterable: true
  },
  {
    id: 'production',
    label: 'Produção média diária',
    type:'number',
    displayInfo: 'Produção/dia(8hrs)'

  }

]


export const MaterialTableConfig : EntityConfig = [

  {
    id: 'id',
    label: 'Id',
    type: 'id',
    nonEditable: true
  },

  {
    id: 'reference',
    label: 'Referência',
    type: 'text',
    filterable: true
  },
  {
    id: 'densidade',
    label: 'Densidade (kg/m3)',
    type: 'number'
  },
  {
    id: 'averagePrice',
    type: 'number',
    label: 'Preço médio (€/kg)',
    filterable: true
  }
]


export const DispositivoMedicaoConfigs : EntityConfig = [

  {
    id: 'id',
    label: 'Id',
    type: 'id',
    nonEditable: true
  },
  {
    id: 'designacao',
    label: 'Designação',
    type: 'text',
  },
  {
    id: 'gama',
    label: 'Gama',
    type: 'text',
  },
  {
    id: 'referencia',
    label: 'Referência',
    type: 'text',
  },
  {
    id: 'calibracao',
    label: 'Calibração',
    type: 'text',
  },
  {
    id: 'periodoCalibracao',
    label: 'Período de calibração',
    type: 'text',
  },
  {
    id: 'ultimaDataVerificacao',
    label: 'Última data de verificação',
    type: 'date',
  },
  {
    id: 'proximaDataVerificacao',
    label: 'Próxima data de verificação',
    type: 'date',
  },
  {
    id: 'entidade',
    label: 'Entidade',
    type: 'text',
  },
  {
    id: 'sectorUso',
    label: 'Sector de uso',
    type: 'enum',
    options: {
      route: 'state',
      getter: async () => (await genericGet('/pecas/operacoes/tipos')).filter((t : string) => [TipoOperacao.ACABAMENTO, TipoOperacao.CNC, TipoOperacao.CONVENCIONAIS, TipoOperacao.CONTROLO_QUALIDADE, TipoOperacao.PROJETO, TipoOperacao.SERROTE].includes(t as TipoOperacao)),
    }
  },

]